import React from "react";

// Official Freeman Jones logo.
export const FreemanJonesLogo = ({ variant = "dark", className = "" }) => {
  const img = (
    <img
      src="/fj-logo.png"
      alt="Freeman Jones"
      width="1366"
      height="320"
      className="h-8 w-auto lg:h-9"
    />
  );

  if (variant === "light") {
    // On dark backgrounds, present on a clean white pill for legibility.
    return (
      <span className={`inline-flex rounded-xl bg-white px-3 py-2 ${className}`}>
        {img}
      </span>
    );
  }

  return <span className={`inline-flex items-center ${className}`}>{img}</span>;
};
